import React from 'react'

import CutToSize from '../components/cut-to-size/CutToSize'
const CutToSizeScreen = props => <CutToSize {...props} />

export default CutToSizeScreen
